import type { IApiResponse, IPartner } from '@/types';
import axios from 'axios';

type IPartnerDTO = Pick<IPartner, 'id' | 'profile_id' | 'name' | 'slug'>;

export function getPartnerBySlug(slug: string) {
  return axios.get<IApiResponse<IPartnerDTO | null>>(`partner/slug/${slug}`);
}
